
import Cookies from 'js-cookie';
import Config from '../core/config';
import {makeRequest} from "../utils/httpRequest";

const apiUrl = Config.apiUrl;

export const getUserPermissions = async () => {
    const userUUID = Cookies.get('userUUID');
    const url = `${apiUrl}/api/users/permissions`;

    const response = await makeRequest(url, 'GET', {
        'Useruuid': userUUID
    });

    return response?.permissions || [];
};


export const getCompanyPermissions = async () => {
    const userUUID = Cookies.get('userUUID');
    const url = `${apiUrl}/api/companies/permissions`;

    const response = await makeRequest(url, 'GET', {
        'Useruuid': userUUID
    });

    return response?.permissions || [];
};
